import Link from 'next/link';

export default function NotFoundPage() {
  return (
    <main className="page">
      <section className="panel hero">
        <p className="eyebrow">404</p>
        <h1>Page introuvable</h1>
        <p className="lead">
          Cette route n’existe pas dans le catalogue statique du MVP WebAR.
        </p>
        <Link href="/" className="button button--primary">
          Retour a l’accueil
        </Link>
      </section>
    </main>
  );
}
